import { render, staticRenderFns } from "./DividerWithText.vue?vue&type=template&id=5d13f82a&scoped=true&"
import script from "./DividerWithText.vue?vue&type=script&lang=ts&"
export * from "./DividerWithText.vue?vue&type=script&lang=ts&"
import style0 from "./DividerWithText.vue?vue&type=style&index=0&id=5d13f82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13f82a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
